import i18n from 'i18next'; 
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(initReactI18next)
.use(LanguageDetector)
.init({
    fallbackLng: 'en',
    resources: {
        en: {
            translation: {
                learn:'Welcome to Integra',
                home: 'Home',
                topBarProfile: 'INTEGRA Environment',
                topBarDash: 'Analytics',
                language: 'Language',
                description: '<p>Welcome to Integra</p>',
                welcome: 'Welcome to Integra',
                buttonStart: 'Begin',
                buttonSubmit: 'Submit',
                buttonNext: 'Next',
                sending: 'Sending...',
                buttonPrevious: 'Previous',
                textplaceholder: 'Type your answer here...',
                overviewSidebar: 'Overview',
                videosSidebar: 'Videos',
                usersSidebar: 'Users',
                surveySidebar: 'Survey',
                relatedSidebar: 'Topics',
                summary: 'Summary',
                totalVideos: 'Total Videos',
                totalVideoViews: 'Total Video Views',
                totalVideoViewsTopic: 'Total Video Views per Topic',
                avgWatchtime: 'Average Watchtime',
                avgWatchtimeTopic: 'Average Watchtime per Topic',
                totalLikes: 'Total Video Likes',
                totalComments: 'Total Comments',
                student: 'Student',
                caregiver: 'Caregiver',
                teacher: 'Teacher',
                classmate: 'Classmate',
                topic: 'Topic',
                likes: 'Likes',
                comments: 'Comments',
                views: 'Views',
                role: 'Role',
                duration: 'Duration',
                fullWatchRate: 'Full Watch Rate',
                relatedTopics: 'Related Topics',
                temperature:  'Weight',
                details: 'Details',
                viewers: 'Viewers',
                intComments: 'Interesting Comments',
                nIntComments: 'Not Interesting Comments',
                newProfile: 'Create New Profile',
                pleaseRespond: 'Please respond to all the questions before proceeding',
                pleaseWait: 'Submitting your survey, please wait...',
                responseSuccess: 'Your responses have been saved successfully!',
                responseFailSa: 'Failed to save responses.',
                responseFailSe: 'Failed to send responses.',
                profileSelect: 'Select a profile',
                selectPlatform: 'Select platform',
                createProfile: 'Profile',
                demo: 'Demo',
                prototype: 'Prototype',
                topVideos: 'Most Viewed Videos',
                topLikedVideos: 'Most Liked Videos',
                profileDescription: 'The Integra platform\'s content and resources are designed to serve the unique cultural and educational needs of each student. The entire IEP team, classmates, and the student will have access to video content that helps expand their knowledge, enhancing the learning experience of Latino students with disabilities. To begin this process, the first step is creating a student profile. In this section, you can view sample student profiles created in Integra and learn about the process and questions asked of parents and teachers during profile creation.',
            },
        },
        es:
        {
            translation: {
                learn: 'Bienvenido a Integra',
                home: 'Inicio',
                topBarProfile: 'Ecosistema INTEGRA',
                topBarDash: 'Analítica',
                language: 'Idioma',
                description: '<p>Welcome to Integra</p>',
                welcome: 'Bienvenido a Integra',
                buttonStart: 'Comenzar',
                buttonSubmit: 'Enviar',
                sending: 'Enviando...',
                buttonNext: 'Siguiente',
                buttonPrevious: 'Anterior',
                textplaceholder: 'Escribe tu respuesta aquí...',
                overviewSidebar: 'General',
                videosSidebar: 'Vídeos',
                usersSidebar: 'Usuarios',
                surveySidebar: 'Encuesta',
                relatedSidebar: 'Tópicos',
                summary: 'Resumen',
                totalVideos: 'Vídeos totales',
                totalVideoViews: 'Vistas totales de vídeo',
                totalVideoViewsTopic: 'Visualizaciones totales de vídeo por tema',
                avgWatchtime: 'Tiempo de visualización promedio',
                avgWatchtimeTopic: 'Tiempo de visualización promedio por tema',
                totalLikes: 'Me gusta de vídeo totales',
                totalComments: 'Comentarios totales',
                student: 'Estudiante',
                caregiver: 'Cuidador',
                teacher: 'Maestro',
                classmate: 'Compañero de clase',
                topic: 'Tema',
                likes: 'Gustos',
                comments: 'Comentarios',
                views: 'Vistos',
                role: 'Role',
                duration: 'Duración',
                fullWatchRate: 'Tasa de visualización completa',
                relatedTopics: 'Tópicos relacionados',
                temperature:  'Pesos',
                details: 'Detalles',
                viewers: 'Espectadores',
                intComments: 'Comentarios interesantes',
                nIntComments: 'Comentarios no interesantes',
                newProfile: 'Crear Nuevo Perfil',
                pleaseRespond: 'Por favor responda a todas las preguntas antes de continuar',
                pleaseWait: 'Enviando su encuesta, por favor espere...',
                responseSuccess: '¡Tus respuestas se han guardado correctamente!',
                responseFailSa: 'No se pudieron guardar las respuestas.',
                responseFailSe: 'No se pudieron enviar respuestas.',
                profileSelect: 'Seleccionar un perfil',
                selectPlatform: 'Seleccionar plataforma',
                createProfile: 'Perfilador',
                demo: 'Demo',
                prototype: 'Prototipo',
                topVideos: 'Vídeos más vistos',
                topLikedVideos: 'Vídeos más gustaron',
                profileDescription: 'El contenido y recursos de la plataforma Integra están diseñados para servir a las necesidades culturales y educativas únicas de cada estudiante. El equipo completo del IEP, compañeros de clase y el estudiante tendrán acceso a contenido de vídeo que ayuda a expandir sus conocimientos, mejorando la experiencia de aprendizaje de los estudiantes latinos con discapacidades. Para comenzar este proceso, el primer paso es crear un perfil de estudiante. En esta sección, puede ver perfiles de estudiantes de muestra creados en Integra y aprender sobre el proceso y las preguntas que se hacen a los padres y maestros durante la creación de un perfil.',
            }
        }
    }

})

